/**
 * Consent banner — show/hide logic for the CMP banner element.
 */

let bannerEl: HTMLElement | null = null;

export function initBanner(el: HTMLElement | null): void {
  bannerEl = el;
}

export function showBanner(): void {
  bannerEl?.removeAttribute('hidden');
}

export function hideBanner(): void {
  bannerEl?.setAttribute('hidden', '');
}

export function removePolicyLink(): void {
  if (!bannerEl) return;
  const link = bannerEl.querySelector('.flt-tm-banner__policy-link');
  if (link?.parentNode) {
    link.parentNode.removeChild(link);
  }
}
